// extracted by mini-css-extract-plugin
export default {"container":"Rm-z","bubbleNav":"Sm-z","graphic":"Tm-z","contact":"Um-z"};